import hyRequest from '../index.js'

// 登录接口
export function accountLoginRequest(account) {
  return hyRequest.post({
    url: '/api/travelagency/login',
    data: {
      Account: account?.Account,
      Password: account?.Password,
      VerifyCode: account?.VerifyCode,
      VerifyCodeKey: account?.VerifyCodeKey
    }
  })
}

// 获取验证码
export function getVerifycode() {
  return hyRequest.post({
    url: '/api/travelagency/verifycode'
  })
}

// 旅行社账号信息
export function getUserInfo() {
  return hyRequest.post({
    url: '/api/travelagency/member/profile'
  })
}

// 账号密码修改
export function changePassword(params) {
  return hyRequest.post({
    url: '/api/travelagency/member/changepwd',
    data: {
      OldPassword: params?.OldPassword,
      NewPassword: params?.NewPassword
    }
  })
}
